// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IApiGeoGetDistrictsTreeRequest,
  TApiGeoGetDistrictsTreeModel,
  IMappers,
  TApiGeoGetDistrictsTreeResponse,
  IApiGeoGetDistrictsTreeResponse,
} from './types';

export const defaultConfig: TApiGeoGetDistrictsTreeModel = {
  apiType: 'legacy',
  assertStatusCodes: [200],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'monolith-cian-realty',
  pathApi: '/api/geo/get-districts-tree/',
} as TApiGeoGetDistrictsTreeModel;

export function createApiGeoGetDistrictsTreeModel(
  parameters: IApiGeoGetDistrictsTreeRequest,
): TApiGeoGetDistrictsTreeModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IApiGeoGetDistrictsTreeOptions<TResponse200> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200>;
  parameters: IApiGeoGetDistrictsTreeRequest;
}

export async function fetchApiGeoGetDistrictsTree<TResponse200>({
  httpApi,
  config,
  mappers,
  parameters,
}: IApiGeoGetDistrictsTreeOptions<TResponse200>): Promise<TApiGeoGetDistrictsTreeResponse | TResponse200> {
  const { statusCode, response, headers } = await httpApi.fetch(createApiGeoGetDistrictsTreeModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IApiGeoGetDistrictsTreeResponse);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TApiGeoGetDistrictsTreeResponse;
}
